import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IPolicyItem } from 'Pages/Customer360/types'

interface IState {
  consent_id: string
  pasSelectedPolicyItem: IPolicyItem | null
  claims_data: any
  claim_consent_id: string
  selectedPolicy: IPolicyItem | null
  policyEndorsementData: any
  policyCancellationData: any
  policyCancellationConsent: string
  policyGrievanceData: any
  grievance_consent_id: string
  policySurrenderData: any
  surrender_consent_id: string
  renewal_data: any
}

const initialState: IState = {
  selectedPolicy: null,
  policyEndorsementData: {},
  consent_id: '',
  pasSelectedPolicyItem: null,
  claims_data: {},
  claim_consent_id: '',
  policyCancellationData: {},
  policyCancellationConsent: '',
  policyGrievanceData: {},
  grievance_consent_id: '',
  policySurrenderData: {},
  surrender_consent_id: '',
  renewal_data: {}
}

const policyDataSlice = createSlice({
  name: 'policyData',
  initialState: initialState,
  reducers: {
    setSelectedPolicy: (state, action: PayloadAction<any>) => {
      state.selectedPolicy = action.payload
    },
    updatePolicyEndorsementData: (state, action: PayloadAction<any>) => {
      state.policyEndorsementData = action.payload
    },
    updateConsentID: (state, action: PayloadAction<string>) => {
      state.consent_id = action.payload
    },
    updatePasSelectedPolicyItem: (state, action: PayloadAction<IPolicyItem | null>) => {
      state.pasSelectedPolicyItem = action.payload
    },
    updateClaimsData: (state, action: PayloadAction<any | null>) => {
      state.claims_data = action.payload
    },
    updateClaimConsentID: (state, action: PayloadAction<string>) => {
      state.claim_consent_id = action.payload
    },
    updatePolicyCancellationData: (state, action: PayloadAction<string>) => {
      state.policyCancellationData = action.payload
    },
    updatePolicyCancellationConsent: (state, action: PayloadAction<string>) => {
      state.policyCancellationConsent = action.payload
    },
    updatePolicyGrievanceData: (state, action: PayloadAction<any>) => {
      state.policyGrievanceData = action.payload
    },
    updateGrievanceConsentID: (state, action: PayloadAction<string>) => {
      state.grievance_consent_id = action.payload
    },
    updatePolicySurrenderData: (state, action: PayloadAction<any>) => {
      state.policySurrenderData = action.payload
    },
    updateSurrenderConsentID: (state, action: PayloadAction<string>) => {
      state.surrender_consent_id = action.payload
    },
    updateRenewalData: (state, action: PayloadAction<any>) => {
      state.renewal_data = action.payload
     }
  },
})

const { reducer } = policyDataSlice

const {
  setSelectedPolicy,
  updatePolicyEndorsementData,
  updateConsentID,
  updatePasSelectedPolicyItem,
  updateClaimsData,
  updateClaimConsentID,
  updatePolicyCancellationData,
  updatePolicyCancellationConsent,
  updatePolicyGrievanceData,
  updateGrievanceConsentID,
  updatePolicySurrenderData,
  updateSurrenderConsentID,
  updateRenewalData
} = policyDataSlice.actions

export {
  reducer as policyDataReducer,
  setSelectedPolicy,
  updatePolicyEndorsementData,
  updateConsentID,
  updatePasSelectedPolicyItem,
  updateClaimsData,
  updateClaimConsentID,
  updatePolicyCancellationData,
  updatePolicyCancellationConsent,
  updatePolicyGrievanceData,
  updateGrievanceConsentID,
  updatePolicySurrenderData,
  updateSurrenderConsentID,
  updateRenewalData
}
